import styled, { css } from 'styled-components';
import { media } from 'src/common/styles/breakpoints';
import MainPageStepsSectionContainer from '@tenant/components/MainPageStepsSectionContainer';
import MainPageHeading from '@tenant/components/MainPageHeading';
import Footer from '@tenant/components/Footer';
import { FC, ReactElement } from 'react';
import { LayoutContainer } from 'src/common/components/Layout/LayoutContainer';

const Content = styled.div`
  display: flex;
  flex-direction: column;

  ${media.w.min.px576(css`
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  `)}
`;

const Info = styled.div`
  ${media.w.min.px768(css`
    max-width: 47.5%;
  `)};

  ${media.w.min.px1366(css`
    max-width: 32.5rem;
  `)};
`;

export type MainPageLayoutProps = {
  tenantLogo: ReactElement;
  stepsList: ReactElement;
  alert: ReactElement;
  consentForm: ReactElement;
};
export const MainPageLayout: FC<MainPageLayoutProps> = ({
  tenantLogo,
  stepsList,
  alert,
  consentForm,
}) => {
  return (
    <LayoutContainer>
      <Content>
        <Info>
          {tenantLogo}
          <MainPageStepsSectionContainer>
            <MainPageHeading
              headingMsgId="main.title"
              descriptionMsgId="main.steps.heading"
            />
            {stepsList}
            {alert}
          </MainPageStepsSectionContainer>
        </Info>
        {consentForm}
      </Content>
      <Footer />
    </LayoutContainer>
  );
};
